import { useQuery } from '@tanstack/react-query';
import { ContestApiResponse } from './queryTypes';

export const useGetContests = (slateId: string) => {
  const params = {
    slateId
  };

  return useQuery<ContestApiResponse[], Error>({
    queryKey: [`${slateId} 'contests'`],
    queryFn: () => {
      const data: Promise<ContestApiResponse[]> = fetch(`${process.env.REACT_APP_API_URL}/api/contests/getSimulatedContests?` + new URLSearchParams(params)).then(res => res.json());

      return data;
    },
    refetchOnWindowFocus: false,
    enabled: slateId ? true : false,
  })
};

export const useGetUsersForContest = (siteContestId: string) => {
  const params = {
    siteContestId
  };

  return useQuery<string[], Error>({
    queryKey: [`users-${siteContestId}`],
    queryFn: () => {
      const data: Promise<string[]> = fetch(`${process.env.REACT_APP_API_URL}/api/contests/getUsersByContest?` + new URLSearchParams(params)).then(res => res.json());

      return data;
    },
    refetchOnWindowFocus: false,
  })
}

export const useGetSports = () => {

  return useQuery<ContestApiResponse[], Error>({
    queryKey: ['contests'],
    queryFn: () => {
      const data: Promise<ContestApiResponse[]> = fetch(`${process.env.REACT_APP_API_URL}/api/contests/getSupportedSports?`).then(res => res.json());

      return data;
    },
    refetchOnWindowFocus: false,
  })
};

export const useGetSites = (sport: string, disable: boolean) => {
  const params = {
    sport,
    contestType: 'PostContest',
    app: 'CONESTSIM'
  };
  return useQuery<ContestApiResponse[], Error>({
    queryKey: [`sites-${sport}`],
    queryFn: () => {
      const data: Promise<ContestApiResponse[]> = fetch(`${process.env.REACT_APP_API_URL}/api/contests/getSupportedSites?` + new URLSearchParams(params)).then(res => res.json());

      return data;
    },
    refetchOnWindowFocus: false,
    enabled: !disable
  })
};